import React, { Component } from "react";
import PropTypes from "prop-types";
import LinksList from "./LinksList";
import onClickOutside from "react-onclickoutside";

class SubMenuList extends Component {
  constructor(props) {
    super(props);
    this.state = { windowHeight: false };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    // the nav we care about is 44 px tall
    const windowHeight = window.innerHeight - (44 + 100);
    return { windowHeight };
  }

  closeMenu() {
    this.props.hideMenuHandler();
  }

  handleClickOutside(event) {
    this.closeMenu();
  }

  render() {
    return (
      <div className="row">
        <div
          style={{ maxHeight: this.state.windowHeight, overflowY: "auto" }}
          className="col-12 col-md-10 offset-md-1 bg-white bg-sm-none shadow-lg p-4"
        >
          <div className="bg-white mx-0">
            <div className="row mx-0">
              <div className="col-6 d-flex float-left px-0">
                <h3 className="d-none d-md-block text-primary pb-3">
                  <strong>
                    <strong>{this.props.item.title}</strong>
                  </strong>
                </h3>
              </div>
              <div className="col-6 d-flex flex-row-reverse float-right px-0">
                <i
                  className="ml-auto fa text-align-right fa-times-circle text-primary"
                  style={{ cursor: "pointer", fontSize: "1.5rem" }}
                  onClick={this.props.hideMenuHandler}
                />
              </div>
              <div className="row w-100 mt-3 mr-0 pb-4 pb-md-0">
                <div className="col-12 col-md-9 pr-0">
                  <LinksList links={this.props.item.links} />
                </div>
                <div className="col-12 col-md-3 px-0 d-flex align-items-end">
                  <img
                    className="d-none d-md-inline img-fluid mx-0"
                    src={this.props.item.img}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * Defines the shape of data sent through for a "List style" sub menu
 */
export const ListItemProps = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      destination: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
          destination: PropTypes.string,
        })
      ),
    })
  ),
});

SubMenuList.propTypes = {
  item: ListItemProps,
  hideMenuHandler: PropTypes.func.isRequired,
};

export default onClickOutside(SubMenuList);



// WEBPACK FOOTER //
// ./resources/assets/js/app/MegaMenu/SubMenuList.js